import React from 'react'

interface Props {
    viewId: string
    children: React.ReactNode | React.ReactNode[]
}

export const Layout: React.FC<Props> = ({ viewId, children }) => {
    return (
        <div className={`membership-app__view membership-app__view--${viewId}`}>
            <div className={'membership-app__view-content'}>
                {children}
            </div>
        </div>
    )
}